<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">疾控智慧实验室管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          疾控智慧实验室管理系统将实验室的各类业务流程、环境、人员、仪器设备、标准物质、化学试剂、标准方法、图书资料、文件记录、科研管理、项目管理等因素统管起来，形成覆盖实验室全要素的综合管理平台。系统集人员管理、仪器设备管理、标准物质管理、库存管理、供应商管理、样品管理、文件管理、方法管理、环境管理以及质量管理等诸多模块为一体，组成一套完整的实验室全面质量监控及管理体系。
        </p>
        <p class="content-paragraph">
          系统既满足实验室日常管理要求，又保证实验数据控制质量，支撑样品从受理、流转、检验到报告编制、审批、合并与核发的全过程闭环管理，并提供可视化智能工作流设置、科室任务管理、查询统计与领导决策支持，实现检验检测业务的标准化、规范化与可追溯化，全面提升疾控实验室的质量管理水平与技术服务能力。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">样品与检验流程</h3>
            <ul class="capability-list"><li>样品受理</li><li>样品流转</li><li>样品分派</li><li>过程监控</li><li>检验结果管理</li><li>检验报告编制</li><li>报告审批</li><li>模板管理</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">资源与质量管理</h3>
            <ul class="capability-list"><li>人员管理</li><li>设备管理</li><li>材料库存管理</li><li>材料预约管理</li><li>试剂及标准物质</li><li>受控文件管理</li><li>质量监督员管理</li><li>可视化工作流</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">环境与决策支持</h3>
            <ul class="capability-list"><li>实验室环境管理</li><li>动物实验室管理</li><li>留样样品库</li><li>恒温恒湿库</li><li>查询统计</li><li>领导查询</li><li>工作量统计</li><li>线上服务</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/lab-sample.svg"
              alt="海南华德科技有限公司 疾控智慧实验室管理系统 - 样品受理 · 流转与检验全过程"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>样品受理 · 流转与检验全过程
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/lab-resource.svg"
              alt="海南华德科技有限公司 疾控智慧实验室管理系统 - 资源管理 · 人员设备试剂与标准物质"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>资源管理 · 人员设备试剂与标准物质
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/lab-report.svg"
              alt="海南华德科技有限公司 疾控智慧实验室管理系统 - 报告管理 · 编制审批与合并发放"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>报告管理 · 编制审批与合并发放
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/lab-quality.svg"
              alt="海南华德科技有限公司 疾控智慧实验室管理系统 - 质量管理 · 全面质量监控体系"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>质量管理 · 全面质量监控体系
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs6.vue